import { createContext, useContext } from 'react'
import { SWPMasterPayload } from '../../types/mf-execution.types'
import { OTPVerificationState, OTPVerificationHandlers } from '../../types/otp.types'

interface SWPContextType {
  swpMasterPayload: SWPMasterPayload
  handleSWPMasterPayload: (payload: SWPMasterPayload) => void
  isSWPOTPVerified: boolean
  handleSWPOTPVerification: (otp: string) => void
  otpVerificationState: OTPVerificationState
  otpVerificationHandlers: OTPVerificationHandlers
}

export const SWPContext = createContext<SWPContextType | undefined>(undefined)

export const useSWPContext = () => {
  const context = useContext(SWPContext)
  if (!context) {
    throw new Error('useSWPContext must be used within a SWPProvider')
  }
  return context
}
